import BadgeMui from '@mui/material/Badge';
import fontStyles from '@shared/design-tokens/fontStyles';
import type { BadgeProps } from './types';

const Badge = ({
  badgeNumber,
  children,
  color = 'coral',
  variant = 'standard',
  marginTop = 0,
  marginRight = 0,
  fullWidthOnMobile = false,
  className,
  sx,
}: BadgeProps) => (
  <BadgeMui
    badgeContent={badgeNumber}
    max={99}
    className={className}
    color={color}
    variant={variant}
    // @ts-ignore
    sx={{
      width: {
        xs: fullWidthOnMobile ? '100%' : 'auto',
        sm: fullWidthOnMobile ? '100%' : 'auto',
        md: 'auto',
      },
      '.MuiBadge-badge': {
        marginTop: `${marginTop !== 0 ? marginTop : '0'}px`,
        marginRight: `${marginRight !== 0 ? marginRight : '0'}px`,
        ...fontStyles.core.textExtraSmall,
        fontSize: '12px',
        // color: 'white',
        // backgroundColor: color,
      },
      ...sx,
    }}
  >
    {children}
  </BadgeMui>
);

export default Badge;
